'use client';

import dynamic from 'next/dynamic';

export const EditorLoader = dynamic(
	() => import('./editor').then((mod) => mod.Editor),
	{ ssr: false },
);
